import { render, staticRenderFns } from "./IntermediateMaterialTransaction.vue?vue&type=template&id=b9253050&scoped=true"
import script from "./IntermediateMaterialTransaction.vue?vue&type=script&lang=js"
export * from "./IntermediateMaterialTransaction.vue?vue&type=script&lang=js"
import style0 from "./IntermediateMaterialTransaction.vue?vue&type=style&index=0&id=b9253050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9253050",
  null
  
)

export default component.exports